import { Routes, Route } from "react-router-dom";

import PaginaPrincipal from "./pages/pagina-principal/PaginaPrincipal";
import Pix from "../src/pages/Pagina-pix/PaginaPix";
import { PaginaBoleto } from "./pages/pagina-boleto";
import ResumoBoleto from "./pages/pagina-boleto/resumo-boleto/index";
import Deposito from "../src/pages/pagina-deposito/index";
import GerarCodigo from "../src/pages/Pagina-pix/gerar-codigo-pix/GerarCodigo";
import Pagar from "../src/pages/pagina-pagar/PaginaPagar";
import CopiarDados from "../src/pages/pagina-deposito/copia-dados-deposito/CopiarDados";
import Transferir from "../src/pages/pagina-transferir/PaginaTransferir";
import CadastrarChavePix from "./pages/Pagina-pix/nova-chave-pix/CadastrarChavePix";
import ConfirmarChavePix from "./pages/Pagina-pix/confirmar-chave-pix/ConfirmarChavePix";
import AppLayout from "./components/App-layout/AppLayout";
import PaginaExtrato from "./pages/pagina-extrato/PaginaExtrato";
import PaginaPerguntasFrequentes from "./pages/pagina-perguntas-frequentes/PaginaPerguntasFrequentes";
import PaginaContato from "./pages/pagina-contato/PaginaContato.jsx";
import {ContactFormPage} from "./pages/pagina-contact-form-page/ContactFormPage";
import TransferirPix from "./pages/Pagina-pix/transferir-pix/TransferirPix";
import { Private } from "./Private";
import PaginaLimitesPix from "./pages/Pagina-pix/limites-pix/PaginaLimitesPix";
import PaginaTedInicial from "./pages/pagina-transferir/pagina-inicial/PaginaTedInicial";
import { PagarBoleto } from "./pages/pagina-boleto/pagar-boleto";
import { TicketProvider } from "./contexts/Tickets/TicketContext";
import { CobrarComBoleto } from "./pages/pagina-boleto/cobrar-com-boleto";
import { BoletoList } from "./pages/pagina-boleto/boleto-list";
import { BoletoPdf } from "./pages/pagina-boleto/boletoPdf";
import { Comprovante } from "./pages/pagina-boleto/comprovante";
import { Settings } from "./pages/configurations";
import { ChargeTicketProvider } from "./contexts/Tickets/ChargeTicket";
import { Login } from "./pages/login";
import { Register } from "./pages/register";
import { AccessLayout } from "./Layouts/AccessLayout";
import { RegisterProvider } from "./contexts/RegisterContext";
import { RegisterPF } from "./pages/register/PF";
import { RegisterPJ } from "./pages/register/PJ";
import RecuperarSenhaPage from "./pages/login/recuperar-senha";
import EsqueciSenha from "./components/login/esqueci-senha/EsqueciSenha";
import PaginaEcheque from "./pages/pagina-E-check/PaginaEcheque";
import PaginaRedeemEcheck from "./pages/pagina-redeem-echeck/PaginaRedeemEcheck";
import {routerLabels} from '../src/utils/routerLabels';
import PaginaEcheckNiquel from "./pages/pagina-echeck-niquel/PaginaEcheckNiquel.jsx";
import PaginaAceitacoes from "./pages/pagina-boleto/pagina-aceitacoes/PaginaAceitacoes.jsx";
import PaginaLimitesTed from "./pages/pagina-transferir/pagina-limites-ted/PaginaLimitesTed.jsx";
import TermsClosurePage from "./pages/Termos/TermsClosurePage.jsx";
import { ContaConsumo } from "./pages/pagina-boleto/pagar-boleto/conta-consumo.jsx";
import Notes from "./pages/pagina-notas/note.jsx";
import { PixParcelado } from "./components/acesso-rapido/pix/pix-parcelado/payment.jsx";
import PaginaPixParcelado from "./components/acesso-rapido/pix/pix-parcelado/index.jsx";
import { PixContractsList } from "./components/acesso-rapido/pix/pix-parcelado/PixPaymentList.jsx";
import FolhaPagamento from "./pages/pagina-folha-pagamento/FolhaPagamento.jsx";
import FolhaDashboard from "./pages/pagina-folha-pagamento/FolhaDashboard.jsx";
import FolhaColaboradores from "./pages/pagina-folha-pagamento/FolhaColaboradoresList.jsx";
import FolhaColaboradoresCreate from "./pages/pagina-folha-pagamento/FolhaColaboradores.jsx";
import FolhaPrevia from "./pages/pagina-folha-pagamento/FolhaPrevia.jsx";
import FolhaStatusPagamentos from "./components/folha-pagamento/status-pagamentos/FolhaStatusPagamentos.jsx";
import { PageCard } from "./components/cartao/Cartao.jsx";
import PaginaFaturaCartao from "./pages/pagina-cartao/fatura/PaginaFaturaCartao.jsx";
import PaginaReceivables from "./pages/pagina-receivables/receivables.jsx";

export default function () {
  return (
    <Routes>
      <Route path="/" element={<AccessLayout />}>
        <Route path="/" element={<Login />} />
        <Route path="/" element={<RegisterProvider />}>
          <Route path="/cadastro" element={<Register />} />
          <Route path="/cadastro/pf" element={<RegisterPF />} />
          <Route path="/cadastro/pj" element={<RegisterPJ />} />
        </Route>
        <Route path="/esqueci-senha" element={<EsqueciSenha />} />
        <Route path="/recuperar-senha/:hash" element={<RecuperarSenhaPage />} />
      </Route>
      <Route path="/boleto-emitido" element={<BoletoPdf />} />
      <Route path="/comprovante" element={<Comprovante />} />
      <Route path="/resgatar-echeck/:identifier" element={<PaginaRedeemEcheck />} />
      <Route path="/termos" element={<TermsClosurePage />} />
      <Route path="/e-check" element={<PaginaEcheckNiquel />} />
      <Route path="/" element={<AppLayout />}>
        <Route path="/" element={<Private />}>
          <Route path="/pagina-principal" element={<PaginaPrincipal />} />
          <Route path="/pagina-aceitacoes" element={<PaginaAceitacoes />} />
          <Route path="/contato" element={<PaginaContato />} />
          <Route path={routerLabels.contactFormPage} element={<ContactFormPage />} />
          <Route
            path="/perguntas-frequentes"
            element={<PaginaPerguntasFrequentes />}
          />
          <Route path="/pagina-extrato" element={<PaginaExtrato />} />
          <Route path="/configuracoes" element={<Settings />} />

          <Route path="/pagina-pix" element={<Pix />} />
          <Route path="/pagina-echeque" element={<PaginaEcheque />} />

          <Route path="/pagina-pagar-pix" element={<TransferirPix />} />
          <Route path="/pagina-pagar-pix/:id" element={<TransferirPix />} />
          <Route path="/pagina-pix-parcelado-pagar" element={<PixParcelado />} />
          <Route path="/pagina-pix-parcelado" element={<PaginaPixParcelado />} />
          <Route path="/pix-contratos" element={<PixContractsList />} />
          <Route path="/gerar-codigo" element={<GerarCodigo />} />
          {/* <Route path="/chave-pix" element={<MinhaChaves />} /> */}
          <Route path="/nova-chave-pix" element={<CadastrarChavePix />} />
          <Route path="/confirmar-chave-pix" element={<ConfirmarChavePix />} />
          <Route path="/limites-pix" element={<PaginaLimitesPix />} />
          <Route path="/limites-ted" element={<PaginaLimitesTed />} />

          <Route path="/pagina-deposito" element={<Deposito />} />
          <Route path="/copiar-dados" element={<CopiarDados />} />

          <Route path="/pagina-transferencia" element={<Transferir />} />
          <Route path="/pagina-ted" element={<PaginaTedInicial />} />

          <Route path="/pagina-pagar" element={<Pagar />} />

          <Route path="/folha-pagamento/dashboard" element={<FolhaDashboard />} />
          <Route path="/folha-pagamento/pagamento" element={<FolhaPagamento />} />
          <Route path="/folha-pagamento/pagamento/:payrollId/status" element={<FolhaStatusPagamentos />} />
          <Route path="/folha-pagamento/colaboradores" element={<FolhaColaboradores />} />
          <Route path="/folha-pagamento/colaborador/:id" element={<FolhaColaboradoresCreate />} />
          <Route path="/folha-pagamento/previa" element={<FolhaPrevia />} />

          <Route path="/pagina-cartao" element={<PageCard />} />
          <Route path="/pagina-cartao/fatura" element={<PaginaFaturaCartao />} />
          
          <Route path="/" element={<TicketProvider />}>
            <Route path="/pagina-boleto" element={<PaginaBoleto />} />
            <Route path="/pagina-pagar-boleto" element={<PagarBoleto />} />
            <Route
              path="/pagina-cobrar-boleto"
              element={
                <ChargeTicketProvider>
                  <CobrarComBoleto />
                </ChargeTicketProvider>
              }
            />
            <Route
              path="/pagina-boleto-list"
              element={
                <ChargeTicketProvider>
                  <BoletoList />
                </ChargeTicketProvider>
              }
            />
            <Route path="pagina-pagar-boleto/conta-consumo" element={<ContaConsumo />} />
            <Route path="/pagina-resumo-boleto" element={<ResumoBoleto />} />
            <Route path="/notas" element={<Notes />} /> 
          </Route>

          <Route path="/pagina-receivables" element={<PaginaReceivables />} />
        </Route>
      </Route>
    </Routes>
  );
}
